import React from 'react';
import { setDataEnvironment, useDataEnvironment, type DataEnvironment } from '../dataEnvironment';

const OPTIONS: { value: DataEnvironment; label: string }[] = [
  { value: 'prod', label: 'PROD' },
  { value: 'tst', label: 'TST' }
];

const DataEnvironmentSelector: React.FC = () => {
  const current = useDataEnvironment();

  return (
    <div className="environment-selector" role="group" aria-label="Data environment">
      {OPTIONS.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          className={`environment-option environment-option-${value} ${
            current === value ? 'environment-option-active' : ''
          }`}
          aria-pressed={current === value}
          onClick={() => current !== value && setDataEnvironment(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default DataEnvironmentSelector;
